import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"

import { get } from "helpers/api_helper"
import TimeSlotForm from "components/TimeSlot/TimeSlotForm"
import SpinnerLoader from "components/Loader/SpinnerLoader"
const EditTimeSlot = props => {
  const [time_slot, setTimeSlot] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    get(`time-slots/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setTimeSlot(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>Time Slot | GoFetchIt</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumb
          breadcrumb1={{
            title: "Time Slots",
            href: "/time-slots",
          }}
          breadcrumbItem="Edit Time Slot"
        />
        {loading ? (
          <SpinnerLoader/>
        ) : (
          <TimeSlotForm
            c_data={time_slot}
            time_slot_id={props.match.params.id}
          />
        )}
      </div>
    </div>
  )
}

export default EditTimeSlot
